const TransferData = [
    {
        key: 1,
        title: "How To Connect Data",
        video: "",
    },
    {
        key: 2,
        title: "Query Editor",
        video: "",
    },
    {
        key: 3,
        title: "Basic Tranformation Properties",
        video: "",
    },
    {
        key: 4,
        title: "Data Preview   ",
        video: "",
    },
    {
        key: 5,
        title: "Text Related Properties",
        video: "",
    },
    {
        key: 6,
        title: "Number related properties",
        video: "",
    },
    {
        key: 7,
        title: "Add Columns - Index & Conditional Columns",
        video: "",
    },
    {
        key: 8,
        title: "Grouping & Aggregating",
        video: "",
    },
    {
        key: 9,
        title: "Merge Queries",
        video: "",
    },
    {
        key: 10,
        title: "Append Queries",
        video: "",
    },
    {
        key: 11,
        title: "Pivoting & Unpivoting",
        video: "",
    },
    {
        key: 12,
        title: "Connecting Folders",
        video: "",
    },
    {
        key: 13,
        title: "Data Source Settings",
        video: "",
    },
    {
        key: 14,
        title: "Importing Data Models from Excel",
        video: "",
    },
    {
        key: 15,
        title: "Calender Table",
        video: "",
    },
    {
        key: 16,
        title: "Best Practices",
        video: "",
    },

];
export default TransferData;